import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { costs } from '../data/copy';
export function ProblemSection() {
  return <section className="defer-paint w-full bg-zinc-900 py-12 sm:py-14" aria-labelledby="problem-heading" data-id="element-155" data-mp="2lqgwkp38r9v5">
      <div className="mx-auto max-w-5xl px-6" data-id="element-156" data-mp="2vqhhgfgrdy1g">
        <SectionHeading eyebrow="Il problema reale" title={<span id="problem-heading" data-id="element-158" data-mp="39hvzaiyxjt6x">Ti suona familiare?</span>} data-id="element-157" data-mp="2vppl32fc7wa4" />

        <div className="mx-auto mt-9 max-w-3xl space-y-5 border-l-2 border-yellow-500/50 pl-6 sm:pl-8" data-id="element-159" data-mp="39g2sn3obh8yx">
          <p className="font-serif text-xl font-bold leading-snug text-stone-100 sm:text-2xl" data-id="element-160" data-mp="35g0wtb59j9rk">
            Sono le 18:00. Tra poco inizia l'allenamento.
          </p>
          <p className="font-sans text-[0.95rem] leading-relaxed text-stone-400" data-id="element-161" data-mp="3ei0jok2yl82f">
            Hai davanti giocatori con livelli diversi, palloni da distribuire,
            una palestra da organizzare e 60 minuti da sfruttare bene.
          </p>
          <p className="font-sans text-[0.95rem] leading-relaxed text-stone-400" data-id="element-162" data-mp="1k5aps2clbyv1">
            Sai che oggi vuoi lavorare sul bagher. O sul palleggio. O sulla
            ricezione.
          </p>
          <p className="font-sans text-[0.95rem] leading-relaxed text-stone-400" data-id="element-163" data-mp="o9u236w3azaq">
            Ma manca ancora una cosa:{' '}
            <span className="font-semibold text-stone-100" data-id="element-164" data-mp="x49vn8ha3hpx">
              una progressione chiara.
            </span>
          </p>
          <p className="font-sans text-[0.95rem] leading-relaxed text-stone-400" data-id="element-165" data-mp="122jsdniniqdn">
            Apri il telefono. Cerchi un esercizio. Poi un altro. Salvi un video.
            Modifichi le distanze. Provi a ricordare cosa avevi fatto la
            settimana precedente.
          </p>
          <p className="font-serif text-lg font-bold leading-snug text-stone-100 sm:text-xl" data-id="element-166" data-mp="1g3nt40e7val6">
            E quando finalmente entri in campo… hai una serie di esercizi, ma
            non necessariamente un allenamento costruito con logica.
          </p>
        </div>

        <div className="mt-12" data-id="element-167" data-mp="p092fveijggn">
          <h3 className="text-center font-serif text-xl font-bold leading-snug text-stone-100 sm:text-2xl" data-id="element-168" data-mp="ozh78lotvkqw">
            Il costo reale di non avere il sistema corretto
          </h3>

          <ul className="mt-7 grid gap-x-8 gap-y-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-169" data-mp="y1gmp9k72grq">
            {costs.map(cost => <li key={cost.title} className="flex gap-3" data-id="element-170" data-mp="tyu1vslxxw41">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-red-600/50 bg-red-600/15" aria-hidden="true" data-id="element-171" data-mp="u1g5xi9mhthi">
                  <XIcon className="h-3 w-3 text-red-400" strokeWidth={3} data-id="element-172" data-mp="12z8ocvan5h94" />
                </span>
                <span data-id="element-173" data-mp="1hnmqf408h1om">
                  <span className="block font-sans text-[0.9rem] font-semibold leading-snug text-stone-100" data-id="element-174" data-mp="1ho4swidhoc4z">
                    {cost.title}
                  </span>
                  <span className="mt-1.5 block font-sans text-[0.82rem] leading-relaxed text-stone-400" data-id="element-175" data-mp="1qqnu6y1mmgp4">
                    {cost.detail}
                  </span>
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}